module.exports = __webpack_public_path__ + "static/media/Upcoming-grads-program-illustration.5ac30cae.svg";